import { useState, useEffect, useRef } from "react";
import { useDisableBodyScroll } from "./usePreventScroll";

export default function useComponentVisibleDropdown(initialIsVisible: any) {
  const { scrollEnable, scrollDisable } = useDisableBodyScroll();

  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);
  const ref = useRef<any>(null);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
      // scrollEnable();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref, isComponentVisible, setIsComponentVisible };
}
